import React, { useState } from 'react';
import {
  useFormContext,
  Controller,
  UseControllerProps,
} from 'react-hook-form';
import TextField, { TextFieldProps } from '@mui/material/TextField';

type FormTextFieldProps = UseControllerProps & {
  inner_props?: TextFieldProps;
  className?: string;
  defaultValue?: string;
};

export default function FormTextField(props: FormTextFieldProps) {
  const { control } = useFormContext();
  const { name } = props;
  const [value, setValue] = useState(props.defaultValue || '');

  return (
    <Controller
      name={name}
      control={control}
      rules={props.rules}
      defaultValue={props.defaultValue || ''}
      render={({ field }) => (
        <TextField
          {...field}
          {...props.inner_props}
          value={value}
          onChange={(e) => {
            field.onChange(e);
            setValue(e.target.value);
          }}
        />
      )}
    />
  );
}
